export const convertHttpToHttps = (url: string) => {
    if (!url.startsWith('http://')) {
        return url; // Return the original URL if it doesn't start with 'http://'
    }
    return url.replace('http://', 'https://');
};
